/* eslint-disable no-redeclare */
import { AppCustomLine as CustomLine, AppProductLine as ProductLine } from 'graphql/models/extended';
import { CustomPricing, ElementPricing, ElementPricingManufacturer } from 'models/pricing.model';

import { isBomSubLine } from './is-bom-sub-line';
import { isExternalArticleLine } from './is-external-article-line';
import { isProductLine } from './is-product-line';

export function getLinePricing(
  options: {
    position: ProductLine | CustomLine;
    isDealer: true;
  }
): ElementPricing[] | CustomPricing[] | undefined;

export function getLinePricing(
  options: {
    position: ProductLine | CustomLine;
    isDealer: false;
  }
): ElementPricingManufacturer[] | undefined;

export function getLinePricing(
  { position }: {
    position: ProductLine | CustomLine;
    isDealer: boolean;
  }
): ElementPricing[] | ElementPricingManufacturer[] | CustomPricing[] | undefined {
  const pos = position as ProductLine;

  // eslint-disable-next-line no-nested-ternary
  return (
    (isProductLine(pos) || isBomSubLine(position))
      && pos.pricing
      && pos.pricing.elements
      && pos.pricing.elements.length > 0
  )
    ? pos.pricing.elements
    : isExternalArticleLine(position) && position.pricing
      ? [position.pricing]
      : undefined;
}
